import { useState } from "react";
import { Button, Dialog, Select, SelectOption } from "@rio-cloud/rio-uikit";
import { Occurrence } from "../../../models/occurrence";
import { useTasOccurrence } from "../../../hooks/useTasOccurrence";

interface ITasNumberRequiredDialogProps {
  show: boolean;
  occurrence: Occurrence | null;
  loading?: boolean;
  onConfirm: (tasNumber: string) => void;
  onCancel: () => void;
}

const TasNumberRequiredDialog = ({
  show,
  occurrence,
  loading = false,
  onConfirm,
  onCancel,
}: ITasNumberRequiredDialogProps) => {
  const [tasNumber, setTasNumber] = useState<string | undefined>(undefined);
  const { tasOccurrences } = useTasOccurrence(occurrence?.vehicleChassis || "", "");

  const handleCancel = () => {
    setTasNumber(undefined);
    onCancel();
  };

  return (
    <Dialog
      show={show}
      title="Número TAS obrigatório"
      body={
        <div className="space-y-4">
          <div className="text-color-status-resting">
            Para mover o chamado para a etapa "4ª Diagnose (TAS)" é
            obrigatório informar o número do chamado TAS vinculado.
          </div>
          <div className="form-group form-group-lg w-full">
            <label htmlFor="tasNumberRequired">Número TAS *</label>
            <Select
              id="tasNumberRequired"
              value={tasNumber ? [tasNumber] : []}
              options={tasOccurrences.map((tas) => ({
                id: tas.tasOccurrenceNumber,
                label: tas.tasOccurrenceNumber,
              })) as SelectOption[]}
              useFilter
              placeholder="Selecione um chamado TAS"
              onChange={(e) => setTasNumber(e?.id)}
            />
          </div>
        </div>
      }
      footer={
        <div className="display-flex justify-content-end">
          <Button
            bsStyle="default"
            onClick={handleCancel}
            className="margin-right-10"
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            bsStyle="primary"
            onClick={() => tasNumber && onConfirm(tasNumber)}
            disabled={loading || !tasNumber}
          >
            {loading ? "Confirmando..." : "Confirmar"}
          </Button>
        </div>
      }
      bsSize={Dialog.SIZE_SM}
      onClose={handleCancel}
    />
  );
};

export default TasNumberRequiredDialog;
